import contactsApi from "./contacts-api";
import {Client} from "../../models/Client";


let clientsApi = {
    async getPricingTables(client, token, companyId){
        let response = await window.axios.get('/api/clients/'+client.id, {
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return !!response.data.success;
    },
    async getRecurrenceClients(token, companyId, recurrenceId, params={}, page=null){
        let response = await window.axios.get('/api/clients/recurrence-clients', {
            params:{
                api_token:token,
                company_logged:companyId,
                recurrence_id:recurrenceId,
                page:page,
                ...params
            }
        });
        return response.data;
    },
    async detachRecurrence(token, companyId, clientId, recurrenceId){
        let response = await window.axios.post('/api/clients/'+clientId+'/detach-recurrence', {
            recurrence_id: recurrenceId
        },{
            params:{
                api_token:token,
                company_logged:companyId,
            }
        });
        return response.data.success;
    },
    ...contactsApi('clients', ['phones','addresses','labels', 'contact_people:id,name,email,type,cpf,company_id', 'contact_people.phones', 'contact_companies:id,name,email,type,cpf,company_id', 'contact_companies.phones', 'extraInfos.options', 'extraInfoValues','pricingTable'])
}

export default clientsApi